import refs from '../refs.js';
import { onCardClick } from '../scripts/modal-data-fetch.js';

refs.cardList.addEventListener('click', onCardClick);
